import { Toast } from "vant";
import { isWechat } from "@/utils/isTerminal.js";

// 拉起微信支付。前提：页面本身在微信内置浏览器打开，不需要额外的JS-SDK签名配置，
// 直接用微信内置的 WeixinJSBridge 就能调，跟现有项目里 payMethod.js 的做法一致。
export function wechatPay(params, onSuccess, onFail) {
  if (!isWechat || typeof window.WeixinJSBridge == "undefined") {
    Toast("请在微信中打开进行支付");
    return;
  }
  window.WeixinJSBridge.invoke(
    "getBrandWCPayRequest",
    {
      appId: params.appId,
      timeStamp: params.timeStamp,
      nonceStr: params.nonceStr,
      package: params.packageValue || params.package,
      signType: params.signType,
      paySign: params.paySign,
    },
    function (res) {
      if (res.err_msg == "get_brand_wcpay_request:ok") {
        // 微信官方提示：err_msg为ok不能100%保证支付成功，只是前端侧的信号，
        // 真正的支付状态要以后端收到的支付回调为准
        onSuccess && onSuccess();
      } else {
        onFail && onFail(res);
      }
    }
  );
}
